/* eslint-disable */
import React, {useState} from 'react';
import Tab from '../../../component/Inc/Tab';
import Paging from '../../../component/Inc/Paging';
import 'contents/assets/scss/page/mypage.scss';
function Payment() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab01 = [
    {title: '전체', value: 0},
    {title: '미납', value: 1},
    {title: '완납', value: 2},
    {title: '선납', value: 3}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap p_payment">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_8 active">과목별 입금 관리</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">입금내역 추가</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="전체">전체</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>

              <div className="com_board_search end">
                <button className="com_btn s lightRed">입금위치 모름(5465)</button>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="com_radio_wrap padding_y">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">전체</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">카드</label>
                <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                <label htmlFor="rdo03">가상계좌</label>
                <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                <label htmlFor="rdo04">현금</label>
              </div>
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>

            <hr className="com_divider" />
            <div className="com_board_list__top">
              <table className="com_board_list type_row end">
                <colgroup>
                  <col width="120" />
                  <col width="160" />
                  <col width="120" />
                  <col width="160" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>총 입금 건수</th>
                    <td>98건</td>
                    <th>총 입금액</th>
                    <td className="td_point">46,500,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="120" />
                <col width="100" />
                <col width="120" />
                <col width="80" />
                <col width="100" />
                <col width="100" />
                <col width="80" />
                <col width="80" />
                <col width="80" />
                <col width="80" />
                <col width="160" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="80" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>
                    입금일&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    학생명&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>과목</th>
                  <th>회차 / T</th>
                  <th>할인</th>
                  <th>상품가격</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>입금자</th>
                  <th>입금방법</th>
                  <th>입금정보</th>
                  <th>입금회차 / 금액</th>
                  <th>수수료</th>
                  <th>발행기준</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2022-08-25</td>
                  <td>홍학생123</td>
                  <td className="td_red">
                    모름
                  </td>
                  <td>16회 / 2T</td>
                  <td>형제할인 2%</td>
                  <td>46,650,000</td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임103</button>
                  </td>
                  <td>김길동</td>
                  <td>카드</td>
                  <td>[국민]6546-645-*****-645</td>
                  <td className="td_point">3회 / 300,000</td>
                  <td>45,000</td>
                  <td className="td_point">54,655,988</td>
                  <td>
                    <button className="btn_link">보기</button>
                  </td>
                </tr>
                {[...Array(9)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>2022-08-25</td>
                    <td>홍학생123</td>
                    <td>
                      수학/본사 <button className="btn_edit_pen_circle"></button>
                    </td>
                    <td>16회 / 2T</td>
                    <td>형제할인 2%</td>
                    <td>46,650,000</td>
                    <td>
                      <button className="btn_link">김교사103</button>
                    </td>
                    <td>
                      <button className="btn_link">김담임103</button>
                    </td>
                    <td>김길동</td>
                    <td>카드</td>
                    <td>[국민]6546-645-*****-645</td>
                    <td className="td_point">3회 / 300,000</td>
                    <td>45,000</td>
                    <td className="td_point">54,655,988</td>
                    <td>
                      <button className="btn_link">보기</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paging />
          </div>
        </section>
      </div>
    </main>
  );
}

export default Payment;
